import { render, staticRenderFns } from "./SampleCoordsManager.vue?vue&type=template&id=e2d9f890"
import script from "./SampleCoordsManager.vue?vue&type=script&lang=js"
export * from "./SampleCoordsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports